import React from 'react';
import {observer} from 'mobx-react';
import {t, withState} from 'shared/core';
import {Layout, Display, Panel} from 'components';
import {BenefitDivisionListState} from '../state';
import BenefitDivisionTable from './BenefitDivisionTable';

const BenefitDivisionList = observer(({uiState, history}) => {
  const {benefitDivisions} = uiState;

  return (
    <div>
      <Display title={t('taxable_benefits.Taxable Benefits')}/>
      <Layout>
        <Panel.Stack loose>
          {benefitDivisions.map(benefitDivision => 
            <BenefitDivisionTable 
              key={benefitDivision.id}
              history={history} 
              benefitDivision={benefitDivision} 
            />
          )}
        </Panel.Stack>
      </Layout>
    </div>
  );
});

export default withState(BenefitDivisionList, BenefitDivisionListState);
